import Text from "@/components/Text";
import "./style.css";

interface CommentProps {
  comment: string;

  handleChangeComment(comment: string): void;
}

function Comment({ comment, handleChangeComment }: CommentProps) {
  return (
    <div>
      <Text
        as="span"
        className="mt-6 block font-normal leading-none"
        kind="blue"
        size="xs"
      >
        No que podemos melhorar?
      </Text>
      <textarea
        className="textArea"
        onChange={(e) => handleChangeComment(e.target.value)}
        maxLength={1000}
        value={comment}
      />
      <Text
        as="span"
        className="mt-1 block font-normal leading-none"
        kind="blue"
        size="xs"
      >
        Até 1000 caracteres
      </Text>
    </div>
  );
}

export default Comment;
